import React from "react";
import Seo from "@/components/Seo";

export default function CGUPage() {
  return (
    <div className="container-x py-16 max-w-3xl" data-testid="cgu-page">
      <Seo
        title="Conditions Générales d'Utilisation"
        description="Conditions Générales d'Utilisation du site Recette-Diabete : accès, propriété intellectuelle, responsabilités."
        path="/cgu"
      />
      <p className="overline mb-3">Cadre juridique</p>
      <h1 className="font-serif text-4xl md:text-5xl mb-8">Conditions Générales d'Utilisation</h1>
      <p className="text-sm text-[hsl(var(--text-secondary))] mb-8">Dernière mise à jour : février 2026</p>

      <div className="prose max-w-none space-y-6 text-[hsl(var(--text-secondary))]">
        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">1. Objet</h2>
          <p>
            Les présentes Conditions Générales d'Utilisation (« CGU ») régissent l'accès et l'utilisation
            du site <strong>Recette-Diabete</strong> (ci-après « le Site »), édité par la société
            OPTIMHUB. En accédant au Site, l'utilisateur reconnaît avoir pris connaissance des présentes
            CGU et s'engage à les respecter.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">2. Accès au Site</h2>
          <p>
            Le Site est accessible gratuitement à toute personne disposant d'un accès à Internet.
            L'éditeur se réserve le droit de suspendre, interrompre ou modifier tout ou partie du Site
            sans préavis, notamment pour des raisons de maintenance ou d'évolution technique.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">3. Contenu et usage</h2>
          <p>
            Les recettes, guides, textes et illustrations publiés sur le Site sont fournis à titre
            informatif et pédagogique. L'utilisateur s'engage à ne pas utiliser le Site à des fins
            illicites, notamment&nbsp;:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>reproduire ou diffuser le contenu sans autorisation écrite préalable&nbsp;;</li>
            <li>tenter d'accéder frauduleusement aux systèmes techniques du Site&nbsp;;</li>
            <li>utiliser des robots ou scripts automatisés pour extraire massivement le contenu&nbsp;;</li>
            <li>publier via les formulaires (newsletter, contact) des contenus injurieux, diffamatoires ou contraires à la loi.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">4. Avertissement médical</h2>
          <p>
            Les informations nutritionnelles et les recettes proposées (index glycémique, valeurs
            nutritionnelles, indications pour personnes diabétiques) sont fournies à titre indicatif.
            <strong> Elles ne constituent en aucun cas un avis médical.</strong> L'utilisateur reconnaît
            que toute modification de son alimentation, en particulier dans le cadre d'un diabète,
            doit faire l'objet d'un avis préalable auprès d'un professionnel de santé qualifié.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">5. Propriété intellectuelle</h2>
          <p>
            L'ensemble des éléments composant le Site (contenu éditorial, images générées par IA,
            architecture, code, marques et logos) est protégé par le droit d'auteur et le droit des
            marques. Toute utilisation non expressément autorisée est constitutive de contrefaçon,
            susceptible d'engager la responsabilité civile et pénale de son auteur.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">6. Données personnelles</h2>
          <p>
            Le traitement des données personnelles est décrit en détail dans notre{" "}
            <a href="/politique-confidentialite" className="text-[hsl(var(--brand-primary))] underline">
              Politique de Confidentialité
            </a>
            . L'utilisateur dispose de droits d'accès, de rectification et de suppression conformément
            au RGPD.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">7. Responsabilité</h2>
          <p>
            OPTIMHUB s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur
            le Site, sans toutefois pouvoir en garantir l'exhaustivité ou l'absence d'erreurs.
            L'éditeur ne saurait être tenu responsable&nbsp;:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>des dommages directs ou indirects résultant de l'utilisation du Site&nbsp;;</li>
            <li>d'une interruption temporaire ou d'un dysfonctionnement du Site&nbsp;;</li>
            <li>des contenus de sites tiers accessibles via des liens hypertextes.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">8. Modification des CGU</h2>
          <p>
            L'éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les CGU
            applicables sont celles en vigueur à la date de connexion et d'utilisation du Site par
            l'utilisateur.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">9. Droit applicable et juridiction</h2>
          <p>
            Les présentes CGU sont régies par le droit français. En cas de litige et à défaut de
            résolution amiable, les tribunaux compétents du ressort du siège social d'OPTIMHUB
            (Paris) seront seuls compétents.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">10. Contact</h2>
          <p>
            Pour toute question relative aux présentes CGU&nbsp;:{" "}
            <a href="mailto:contact@recette-diabete.com" className="text-[hsl(var(--brand-primary))] underline">
              contact@recette-diabete.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
